import { scaleLog } from 'd3-scale';
import { OutliersDataItem } from 'widgets/outliers/data/outliersData';

export const getSizeScale = (
    plotAreaWidth: number,
    plotAreaHeight: number,
    dataItems: OutliersDataItem[]
) => {
    const values = dataItems.map((d) => d.value);
    const minValue = Math.min(...values);
    const maxValue = Math.max(...values);
    const min = 20;
    const max = Math.max(Math.min(plotAreaWidth, plotAreaHeight) / 3, min);

    return {
        max,
        scale: scaleLog().domain([minValue, maxValue]).range([min, max]),
    };
};
